import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { featuredServices, stethoscopeImage } from "@/mocks/ppcare";

export default function ServicesSection() {
  return (
    <section id="services" className="relative overflow-hidden bg-background-50 py-16 md:py-24">
      <img
        src={stethoscopeImage}
        alt=""
        className="pointer-events-none absolute -right-10 top-40 hidden w-52 opacity-30 xl:block"
      />
      <div className="container relative z-10">
        <Reveal>
          <SectionHeading
            eyebrow="What We Offer"
            title={
              <>
                In-House Featured <span className="text-accent-500">Services</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {featuredServices.map((service, index) => (
            <Reveal key={service.title} delay={(index % 3) * 90}>
              <div className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-shadow duration-300 hover:border-primary-200">
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-full w-full object-cover object-center"
                  />
                  <div className="absolute bottom-0 left-1/2 flex h-14 w-14 -translate-x-1/2 translate-y-1/2 items-center justify-center rounded-full border-4 border-background-50 bg-primary-500 text-2xl text-background-50">
                    <i className={service.icon} />
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-6 pt-12 text-center">
                  <h3 className="text-lg font-bold text-foreground-900">{service.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                    {service.text}
                  </p>
                  <a
                    href="#services"
                    className="mt-5 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500 px-5 py-2.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    Learn More
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#services"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            View All Services
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}